import axios from "axios";
import { useQuery } from "react-query";
import { useGetUserInfo } from "hooks/useGetUserInfo";
import { END_POINT } from "config/environment";
import { TCampaignSignupsPaginated } from "../types";

export const QUERY_KEY_CAMPAIGN_SIGNUPS = "admin-campaign-signups";

const getData = async (props: {
  token: string;
  id: string;
  page: number;
  signup_type?: string;
}): Promise<TCampaignSignupsPaginated> => {
  const url = `${END_POINT.BASE_URL}/v1/administrator/campaigns/${props.id}/signups`;
  const res = await axios.get<TCampaignSignupsPaginated>(url, {
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${props.token}`,
    },
    params: {
      page: props.page,
      per_page: 15,
      ...(props.signup_type ? { signup_type: props.signup_type } : {}),
    },
  });
  return res.data;
};

export const useGetCampaignSignups = (
  id: string | undefined,
  page: number,
  signup_type?: string
) => {
  const { token } = useGetUserInfo();
  return useQuery(
    [QUERY_KEY_CAMPAIGN_SIGNUPS, id, page, signup_type ?? ""],
    () =>
      getData({
        token,
        id: id!,
        page,
        signup_type,
      }),
    { enabled: !!id, keepPreviousData: true }
  );
};
